<app-course-header></app-course-header>
<div class="UNFAPP-signlog-full-area">
    <div class="UNFAPP-signlog-frm-wrpbx">
        <div class="UNFAPP-signlog-frmbx">
            <div class="UNFAPP-signlog-hdng-wrap">
                <h2 class="UNFAPP-signlog-hdng">Welcome to Infinity Learn</h2>
                <h3 class="UNFAPP-signlog-stphdng">You are 2 steps away from starting your learning journey</h3>
                <!-- <h3 class="UNFAPP-acnt-link-hdng">I already have an account <a href="#">Click here</a></h3> -->
            </div>

            <div class="UNFAPP-signlog-tabarea">
                <div class="UNFAPP-signlog-tab-btn-area">
                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" [ngClass]='{"active":signupTab}' data-toggle="tab" role="tab" (click)="gotoTab('signup')">Sign up</a>
                        </li>
                        <li class="nav-item" role="presentation">
                            <a class="nav-link" [ngClass]='{"active":!signupTab}' data-toggle="tab" role="tab" (click)="gotoTab('signin')">Sign
                                in</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content" id="myTabContent" *ngIf="signupTab != null">
                    <!-- signup -->
                    <div class="tab-pane fade" [ngClass]='{"show active": signupTab}' id="signup" role="tabpanel">
                        <div class="UNFAPP-tab-wrap">
                            <div class="UNFAPP-signlog-form-area" [formGroup]='signupForm'>


                                <div class="UNFAPP-form-fld-row">
                                    <div class="UNFAPP-form-fld-wrp UNFAPP-phncuntry-drpdwn UNFAPP-wthicon">
                                        <span class="UNFAPP-frmicon"><img src="assets/img/phone-icon.png"
                                                alt="" /></span>
                                        <div class="UNFAPP-phncuntry-fldgrp">
                                            <select>
                                                <option selected>+91</option>
                                            </select>
                                            <input type="text" placeholder="Phone Number" maxlength="10"
                                                formControlName='phone'
                                                onkeypress="return event.charCode>= 48 && event.charCode<=57" onlyNumber
                                                (keyup)="verifyPhoneNumber(); showAccountExist = false" />
                                        </div>
                                    </div>
                                    <label class="UNFAPP-fld-error"
                                        *ngIf="showAccountExist && !((reg.phone.touched && reg.phone.errors?.required)||(reg.phone.touched && reg.phone.errors?.minlength || reg.phone.touched && mob.phone.errors?.maxlength))">*Account
                                        already exists,
                                        please click <a routerLink='/signin'>sign in</a> to
                                        continue</label>
                                    <label class="UNFAPP-fld-error"
                                        *ngIf="reg.phone.touched && reg.phone.errors?.required">*Required</label>
                                    <mat-error class="UNFAPP-fld-error"
                                        *ngIf="reg.phone.touched && reg.phone.errors?.minlength || reg.phone.touched && mob.phone.errors?.maxlength">
                                        *Mobile number should be 10 digits
                                    </mat-error>
                                </div>



                                <div class="UNFAPP-form-fld-row">
                                    <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                                        <span class="UNFAPP-frmicon"><img src="assets/img/name-icon.png"
                                                alt="" /></span>
                                        <input type="text" class="UNFAPP-form-fld" formControlName='firstName'
                                            placeholder="First Name">
                                    </div>
                                    <label class="UNFAPP-fld-error"
                                        *ngIf="reg.firstName.touched && reg.firstName.errors?.required">*Required</label>
                                </div>
                                <div class="UNFAPP-form-fld-row">
                                    <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon">
                                        <span class="UNFAPP-frmicon"><img src="assets/img/name-icon.png"
                                                alt="" /></span>
                                        <input type="text" class="UNFAPP-form-fld" formControlName='lastName'
                                            placeholder="Last Name">
                                    </div>
                                    <label class="UNFAPP-fld-error"
                                        *ngIf="reg.lastName.touched && reg.lastName.errors?.required">*Required</label>
                                </div>

                                <div class="UNFAPP-signlog-grdarea">
                                    <h3 class="UNFAPP-signlog-hdng lightbold sm-hdng" *ngIf='!isILITE || !gradeDisabled'>Select your current grade</h3>
                                    <h3 class="UNFAPP-signlog-hdng lightbold sm-hdng" *ngIf='isILITE || gradeDisabled'>Selected grade</h3>

                                    <ul class="UNFAPP-grdlist-area">
                                        <ng-container *ngFor="let grade of grades">
                                            <li>
                                                <label class="UNFAPP-grd-radio">
                                                    <input type="radio" name="grade" [checked]='checked(grade)' [disabled]="isILITE || gradeDisabled" (click)="selectedGrade(grade)">
                                                    <div *ngIf="grade.name != '13th'" class="UNFAPP-grd-radiobx">{{grade.name.slice(0,-2)}}</div>
                                                    <div *ngIf="grade.name == '13th'" class="UNFAPP-grd-radiobx">{{grade.name.slice(0,-2)}}
                                                        <span class="UNFAPP-update-txt s13">(Repeater) </span></div>
                                                </label>
                                            </li>
                                        </ng-container>
                                    </ul>
                                </div>

                                <div class="UNFAPP-update-txt text-center">
                                    <label class="whtapp-custom-checkbox">
                                    <input type="checkbox" formControlName='whatsappConsent'> <span>Receive updates on Whatsapp</span></label>
                                </div>

                                <div class="UNFAPP-update-txt text-center">
                                    <label class="whtapp-custom-checkbox">
                                    <input type="checkbox" (change)="isAgreedToTC = !isAgreedToTC"> <span class="UNFAPP-terms-text">By signing up you agree to our <br> <a (click)="openTermsAndConditionsDialog()">T & C</a> and <a (click)='openPrivacyPolicyDialog()'>Privacy
                                        Policy</a></span></label>
                                </div>
                                <!-- <p class="UNFAPP-terms-text">By signing up you agree to our <a (click)="openTermsAndConditionsDialog()">T&C</a> and <a (click)='openPrivacyPolicyDialog()'>Privacy
                                        Policy</a>
                                </p> -->

                                <div class="UNFAPP-frm-actn-area">
                                    <button class="UNFAPP-blue-btn UNFAPP-full-btn"
                                        [disabled]='(!signupForm.valid || showAccountExist) && !isAgreedToTC' (click)='formSubmit()'>GET
                                        OTP</button>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!-- signin -->
                    <div class="tab-pane fade" [ngClass]='{"show active": !signupTab}' id="signin" role="tabpanel">

                        <div class="UNFAPP-tab-wrap" *ngIf='!forgotPassword'>
                            <div class="UNFAPP-loginvia-sectn">
                                <div class="UNFAPP-loginvia-hdngarea" *ngIf='!passwordReseted'>
                                    <h3 class="UNFAPP-loginvia-hdng" *ngIf='!isOtpLogin'>Sign In with Password</h3>
                                    <h3 class="UNFAPP-loginvia-hdng" *ngIf="isOtpLogin">Sign In via OTP</h3>

                                    <h4 class="UNFAPP-loginvia-subhdng" *ngIf='!isOtpLogin'>Please enter your password to login and get started
                                    </h4>
                                    <h4 class="UNFAPP-loginvia-subhdng" *ngIf='isOtpLogin'>Please select how you would like to login
                                    </h4>
                                </div>
                                <div class="UNFAPP-loginvia-hdngarea" *ngIf='passwordReseted'>
                                    <h3 class="UNFAPP-loginvia-hdng">Great! Password has been reset.</h3>
                                    <h4 class="UNFAPP-loginvia-subhdng">Please enter your password to login and get
                                        started
                                    </h4>
                                </div>
                                <div class="UNFAPP-loginvia-fromarea">
                                    <div class="UNFAPP-form-fld-row">
                                        <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon UNFAPP-phncuntry-drpdwn"  [formGroup]="loginForm">
                                            <span class="UNFAPP-frmicon"><img src="assets/img/phone-icon.png"
                                                    alt="" /></span>
                                            <div class="UNFAPP-phncuntry-fldgrp">
                                                <select *ngIf="isOtpLogin">
                                                    <option selected>+91</option>
                                                </select>
                                                <select *ngIf="!isOtpLogin" #isdList  (change)="onISDChange(isdList.value)">
                                                    <option *ngFor="let isd of isdCodes" [selected]="isd.selected">{{isd.countryCode}}</option>
                                                </select>
                                                <!-- <div class="dummy-phone"> -->
                                                    <input type="text" maxlength="10"
                                                        placeholder="Phone Number"
                                                        autocomplete="off"
                                                        name="phone" formControlName="phone" onkeypress="return event.charCode>= 48 && event.charCode<=57" onlyNumber
                                                        (keyup)="verifyPhoneNumberLogin(); showAccountExistLogin = false" >
                                                        <!-- <span type="text" class="dummyPhone"></span>
                                                        (keyup)="verifyPhoneNumberLogin(); showAccountExistLogin = false" class="login-phone-dummy">
                                                </div> -->
                                                
                                            </div>
                                        </div>
                                        
                                        <label class="UNFAPP-fld-error"
                                            *ngIf="mob.phone.touched && mob.phone.errors?.required">*Required</label>
                                        <mat-error class="UNFAPP-fld-error"
                                            *ngIf="mob.phone.touched && mob.phone.errors?.minlength || mob.phone.touched && mob.phone.errors?.maxlength">
                                            *Mobile number should be 10 digits
                                        </mat-error>

                                        <!-- <mat-error class="UNFAPP-fld-error"
                                            *ngIf=">
                                            *Invalid mobile number
                                        </mat-error> -->

                                        <label class="UNFAPP-fld-error" *ngIf="showInvalidMobileNumber">
                                        Invalid mobile number</label>

                                        <!-- <label class="UNFAPP-fld-error" *ngIf="showAccountExistLogin && !((reg.phone.touched && reg.phone.errors?.required)||(reg.phone.touched && reg.phone.errors?.minlength || reg.phone.touched && mob.phone.errors?.maxlength))">*Seems like you are a new user,
                                            please click <a routerLink='/signup'>signup</a> to
                                            continue</label> -->
                                        <label class="UNFAPP-fld-error"
                                            *ngIf="(showAccountExistLogin) && !((reg.phone.touched && reg.phone.errors?.required)||(reg.phone.touched && reg.phone.errors?.minlength || reg.phone.touched && mob.phone.errors?.maxlength))">*Seems
                                            like you are a new user,
                                            please click <a routerLink='/signup'>sign up</a> to
                                            continue</label>
                                        <!-- <label class="UNFAPP-fld-error">*Account already exists, please click on login to continue</label> -->
                                    </div>
                                    <div class="UNFAPP-form-fld-row" *ngIf='!isOtpLogin'>
                                        <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon" [formGroup]='passwordForm'>
                                            <span class="UNFAPP-frmicon"><img src="assets/img/password-lock.svg"
                                                    alt="" />
                                            </span>
                                            <div>
                                                <span class="UNFAPP-frm-eyeicon" (click)='togglePass()'>
                                                    <img *ngIf='show_button' src="assets/img/eye-slash.svg" alt="">
                                                    <img *ngIf='!show_button' src="assets/img/eye-icon.svg" alt="">
                                                </span>
                                            </div>
                                            <!-- <div class="dummy-pwd"> -->
                                                <input [type]="show_button ? 'text' : 'password'" oncopy="return false"
                                                    onpaste="return false" class="UNFAPP-form-fld UNFAPP-passoverlap-gap" placeholder="Password"
                                                    formControlName='password'>
                                                    <!-- formControlName='password'  (keyup)="restToDummyPwd()" [ngClass]="!show_button ? 'login-pws-dummy' : ''"> -->
                                                    <!-- <span class="dummyPwd" *ngIf="!show_button"></span> -->
                                            <!-- </div> -->
                                            


                                        </div>
                                        <label class="UNFAPP-fld-error"
                                            *ngIf="pwd.password.touched && pwd.password.errors?.required">*Required</label>
                                        <mat-error class="UNFAPP-fld-error"
                                            *ngIf="pwd.password.touched && pwd.password.errors?.minlength">
                                            *Password should be atleast 6 characters
                                        </mat-error>
                                        <label class="UNFAPP-fld-error"
                                            *ngIf='passwordError && !(pwd.password.touched && pwd.password.errors?.required || pwd.password.touched && pwd.password.errors?.minlength)'>
                                            {{UnauthorizedLoginMessage}}
                                        </label>
                                    </div>
                                    <div class="UNFAPP-forgotpass" *ngIf='!isOtpLogin'>
                                        <a class="UNFAPP-txt-link" (click)='forgotPassword = true'>FORGOT PASSWORD?</a>
                                    </div>
                                    <div class="UNFAPP-loginvia-actnarea">
                                        <button type="button" class="UNFAPP-blue-btn UNFAPP-full-btn"
                                            *ngIf='!isOtpLogin' (click)="verifyPassword()"
                                            [disabled]='!loginForm.valid || !passwordForm.valid'>LOGIN</button>
                                    </div>
                                    <div class="UNFAPP-loginvia-actnarea">
                                        <button type="button" class="UNFAPP-blue-btn UNFAPP-full-btn" *ngIf='isOtpLogin'
                                            (click)="otpLogin()"
                                            [disabled]="(!loginForm.valid || showAccountExistLogin || disabledGetOtpBtn)">GET OTP</button>
                                    </div>
                                    <div class="UNFAPP-logwthpass">
                                        <a class="UNFAPP-txt-link" *ngIf='isOtpLogin && !isILITE' (click)='changeLoginType()'>LOGIN
                                            WITH PASSWORD</a>
                                    </div>
                                    <div class="UNFAPP-logwthpass">
                                        <a class="UNFAPP-txt-link" *ngIf='!isOtpLogin' (click)='changeLoginType()'>Sign In 
                                            WITH OTP</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="UNFAPP-tab-wrap" *ngIf='forgotPassword'>
                            <div class="UNFAPP-loginvia-sectn">
                                <div class="UNFAPP-loginvia-hdngarea">
                                    <h3 class="UNFAPP-loginvia-hdng">Forgot Password</h3>
                                    <h4 class="UNFAPP-loginvia-subhdng">Please enter your registered phone number to
                                        reset your password
                                    </h4>
                                </div>
                                <div class="UNFAPP-loginvia-fromarea">
                                    <div class="UNFAPP-form-fld-row">
                                        <div class="UNFAPP-form-fld-wrp UNFAPP-wthicon UNFAPP-phncuntry-drpdwn" [formGroup]="loginForm">
                                            <span class="UNFAPP-frmicon"><img src="assets/img/phone-icon.png"
                                                    alt="" /></span>
                                            <div class="UNFAPP-phncuntry-fldgrp">
                                                <select>
                                                    <option selected>+91</option>
                                                </select>
                                                <input type="text" maxlength='10'
                                                    placeholder="Phone Number" name="phone" formControlName="phone"
                                                     onkeypress="return event.charCode>= 48 && event.charCode<=57" onlyNumber>
                                            </div>
                                        </div>
                                        <label class="UNFAPP-fld-error"
                                            *ngIf="mob.phone.touched && mob.phone.errors?.required">*Required</label>
                                        <mat-error class="UNFAPP-fld-error"
                                            *ngIf="mob.phone.touched && mob.phone.errors?.minlength || mob.phone.touched && mob.phone.errors?.maxlength">
                                            *Mobile number should be 10 digits
                                        </mat-error>
                                        <!-- <label class="UNFAPP-fld-error">*Account already exists, please click on login to continue</label> -->
                                    </div>


                                    <div class="UNFAPP-loginvia-actnarea">
                                        <button type="button" class="UNFAPP-blue-btn UNFAPP-full-btn"
                                            (click)="otpLogin()" [disabled]='!loginForm.valid'>SEND OTP</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<app-course-footer></app-course-footer>